import React from "react";
import {
  Box,
  FormControlLabel,
  InputLabel,
  RadioGroup,
  Radio,
  Select,
  MenuItem,
} from "@mui/material";

import { useStyles } from "../CreateLeague";
import { noOfPlayers, scoringMethod } from "../mockData";

const DMPFields = ({ leagueData, handleFieldChange }) => {
  const classes = useStyles();

  return (
    <>
      <Box sx={{ mb: 1.5 }}>
        <InputLabel className={classes.inputLableStyles}>
          Scoring Method
        </InputLabel>

        <Select
          fullWidth
          variant="outlined"
          name="scoringMethod"
          value={leagueData.scoringMethod}
          className={classes.textFieldStyles}
          onChange={(e) => handleFieldChange(e.target.value, "scoringMethod")}
        >
          {scoringMethod.map(({ id, name }) => (
            <MenuItem key={id} value={name}>
              {name}
            </MenuItem>
          ))}
        </Select>
      </Box>

      <Box sx={{ mb: 1.5 }}>
        <InputLabel className={classes.inputLableStyles}>
          3rd Position Play Off
        </InputLabel>

        <RadioGroup
          row
          value={leagueData.third_position_play_off}
          name="third_position_play_off"
        >
          <FormControlLabel
            value={true}
            control={<Radio />}
            label="ON"
            onChange={(e) =>
              handleFieldChange(e.target.value, "third_position_play_off")
            }
          />
          <FormControlLabel
            value={false}
            control={<Radio />}
            label="OFF"
            onChange={(e) =>
              handleFieldChange(e.target.value, "third_position_play_off")
            }
          />
        </RadioGroup>
      </Box>

      <Box sx={{ mb: 1.5 }}>
        <InputLabel className={classes.inputLableStyles}>
          No. of Teams
        </InputLabel>

        <Select
          fullWidth
          variant="outlined"
          name="noOfTeams"
          value={leagueData.noOfTeams}
          className={classes.textFieldStyles}
          onChange={(e) => handleFieldChange(e.target.value, "noOfTeams")}
        >
          {noOfPlayers.map(({ id, number }) => (
            <MenuItem key={id} value={number}>
              {number}
            </MenuItem>
          ))}
        </Select>
      </Box>
    </>
  );
};

export default DMPFields;
